import { hasKey, hasKeyWithType } from '@pn/core/utils/logic';
import { isNil, isObject, isString } from 'lodash-es';

export * from './conversion';
export * from './format';

export type SIUnit = {
  value: number | undefined;
  symbol: string;
};

export function toSIUnit(params: {
  value: number | undefined;
  symbol: string;
}): SIUnit {
  return params;
}

export function isSIUnit(arg: unknown): arg is SIUnit {
  return (
    isObject(arg) &&
    hasKey(arg, 'value') &&
    hasKeyWithType(arg, 'symbol', isString)
  );
}

export function sumSIUnits(units: SIUnit[]): SIUnit {
  return units.reduce<SIUnit>(
    (acc, { value, symbol }) => {
      if (isNil(value)) return acc;
      if (symbol !== acc.symbol) throw new Error('Incompatible units');

      return {
        value: isNil(acc.value) ? value : acc.value + value,
        symbol,
      };
    },
    { value: undefined, symbol: units[0]?.symbol ?? '' }
  );
}
